import { render } from "./holiday.vue?vue&type=template&id=2731d73f"
import script from "./holiday.vue?vue&type=script&lang=js"
export * from "./holiday.vue?vue&type=script&lang=js"

import "./holiday.vue?vue&type=style&index=0&id=2731d73f&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__